import {SvgIcon} from "@mui/material";
import * as React from "react";

const PhoneIcon = (props: any) => (
  <SvgIcon
    {...props}
    style={{
      fontSize: "25px",
      position: "absolute",
      left: "-10px",
      top: "10px",
    }}
  >
    <path
      fill="none"
      stroke="#fff"
      d="M10.985,3.917A3.021,3.021,0,0,1,13.372,6.3M10.985,1.5a5.438,5.438,0,0,1,4.8,4.8m-.6,4.822v1.813a1.208,1.208,0,0,1-1.317,1.208,11.957,11.957,0,0,1-5.214-1.855A11.782,11.782,0,0,1,5.028,8.66,11.957,11.957,0,0,1,3.173,3.421,1.208,1.208,0,0,1,4.375,2.1H6.188A1.208,1.208,0,0,1,7.4,3.143a7.758,7.758,0,0,0,.423,1.7,1.208,1.208,0,0,1-.272,1.275l-.767.767a9.667,9.667,0,0,0,3.625,3.625l.767-.767a1.208,1.208,0,0,1,1.275-.272,7.758,7.758,0,0,0,1.7.423A1.208,1.208,0,0,1,15.184,11.119Z"
      transform="translate(-2.667 -0.948)"
    />
  </SvgIcon>
);
export default PhoneIcon;
